module.exports = __webpack_public_path__ + "img/role_wyqt.0a1b7656.jpg";